import {HTMLAttributes} from "react";
import {cva, type VariantProps } from "class-variance-authority";
import {cn} from "../../lib/Utils";

const cardProps = cva(
    "group bg-surface-900 border border-surface-800 rounded-xl " +
    "flex flex-col justify-between",
    {
        variants: {
            padding: {
                none: "p-0",
                small: "p-4",
                medium: "p-5 sm:p-6",
                large: "p-6 sm:p-8",
            },
            position : {
                start : "items-start",
                center : "items-center",
                end : "items-end",
            },
            shadow: {
                none: "shadow-none",
                medium: "shadow-md",
                large: "shadow-lg",
                xl: "shadow-xl",
            },
            hover: {
                true: "hover:border-brand-500 hover:shadow-2xl hover:shadow-brand-900/10 " +
                      "transition-all duration-300 hover:-translate-y-1 hover:scale-[1.03]",
                false: "",
            },
            backdrop: {
                true : "bg-black/70 backdrop-blur-md",
                false : "",
            }
        },
        defaultVariants: {
            padding: "small",
            shadow: "none",
            hover: false,
            backdrop: false,
        },
    }
);

export interface CardProps
    extends HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof cardProps> {}

const Card = ({
                  className,
                  padding,
                  position,
                  shadow,
                  hover,
                  backdrop,
                  children,
                  ...props
              }: CardProps) => {
    return (
        <div
            className={cn(
                cardProps({ padding, position, shadow, hover, backdrop }),
                className
            )}
            {...props}
        >
            {children}
        </div>
        
    );
};

export { Card };